import { render, staticRenderFns } from "./ViewNotFound.vue?vue&type=template&id=50694a97&"
import script from "./ViewNotFound.vue?vue&type=script&lang=js&"
export * from "./ViewNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports